import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Tooltip } from "antd";
import Logo from "../../../assets/images/logo-without-bg.png";
import userIcon from "../../../assets/images/userIcon.svg";
import Logout from "../../../assets/images/logout-new.svg";
import POSIcon from "./SvgComponent/POS";
import ParkedBillIcon from "./SvgComponent/ParkedBill";
import CashManagementIcon from "./SvgComponent/CashManagementIcon";
import SalesHistoryIcon from "./SvgComponent/SalesHistoryIcon";
import SyncIcon from "./SvgComponent/SyncIcon";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useAuthStore from "../../../stores/useAuthStore";

const SidebarNav = ({ keyValue, handleKeyvalue }) => {
  const history = useHistory();

  return (
    <div style={{ backgroundColor: "#fff", height: "100vh", width: "6.7%", borderRight: "1px solid #d9d9d9" }}>
      <Row gutter={[0, 16]}>
        <Col span={24} style={{ marginTop: "1.4vh" }}>
          <Tooltip title="Back to CW Browser">
            <button
              data-testid="pos-home-btn"
              onClick={() => history.push("/")}
              style={{
                width: "100%",
                background: "#fff",
                color: "#ffffff",
                border: "1px solid #fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img src={Logo} alt="CW Browser Home" style={{ height: "4.5vw" }} />
            </button>
          </Tooltip>
        </Col>

        {/* POS */}
        <Col
          span={1}
          className="antd-col-1"
          style={keyValue === "0" ? { backgroundColor: "#A4CD38", marginTop: "0.7vh" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
        />
        <Col id="step1" span={23} style={{ marginTop: "0.7vh" }}>
          <button
            className="cartMenuItems"
            style={keyValue === "0" ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
            onClick={() => handleKeyvalue("0")}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <POSIcon color={keyValue === "0" ? "#FFF" : "#555359"} />
              <span className="posIcon" style={{ color: keyValue === "0" ? "#fff" : "#555359" }}>
                Point of Sale
              </span>
            </div>
          </button>
        </Col>

        {/* Parked Bills */}
        <Col
          span={1}
          className="antd-col-1"
          style={keyValue === "1" ? { backgroundColor: "#A4CD38", marginTop: "1.4vh" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
        />
        <Col id="step2" span={23} style={{ marginTop: "1.4vh" }}>
          <button
            className="cartMenuItems"
            style={keyValue === "1" ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
            onClick={() => handleKeyvalue("1")}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <ParkedBillIcon color={keyValue === "1" ? "#FFF" : "#555359"} />
              <span className="posMenuIcons" style={{ color: keyValue === "1" ? "#fff" : "#555359", paddingTop: "0px" }}>
                Parked bills
              </span>
            </div>
          </button>
        </Col>

        {/* Cash Management */}
        <Col
          span={1}
          className="antd-col-1"
          style={keyValue === "2" ? { backgroundColor: "#A4CD38", marginTop: "2vh" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
        />
        <Col id="step3" span={23} style={{ marginTop: "2vh" }}>
          <button
            className="cartMenuItems"
            style={keyValue === "2" ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
            onClick={() => handleKeyvalue("2")}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <CashManagementIcon color={keyValue === "2" ? "#FFF" : "#555359"} />
              <span className="posMenuIcons" style={{ color: keyValue === "2" ? "#fff" : "#555359", paddingTop: "0px" }}>
                Cash Management
              </span>
            </div>
          </button>
        </Col>

        {/* Sales History */}
        <Col
          span={1}
          className="antd-col-1"
          style={keyValue === "3" ? { backgroundColor: "#A4CD38", marginTop: "1.8vh" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
        />
        <Col id="step4" span={23} style={{ marginTop: "1.8vh" }}>
          <button
            className="cartMenuItems"
            style={keyValue === "3" ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
            onClick={() => handleKeyvalue("3")}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <SalesHistoryIcon color={keyValue === "3" ? "#FFF" : "#555359"} />
              <span className="posIcon" style={{ color: keyValue === "3" ? "#fff" : "#555359" }}>
                Sales History
              </span>
            </div>
          </button>
        </Col>

        {/* Product Sync */}
        <Col
          span={1}
          className="antd-col-1"
          style={keyValue === "4" ? { backgroundColor: "#A4CD38", marginTop: "1.2vh" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
        />
        <Col id="step5" span={23} style={{ marginTop: "1.2vh" }}>
          <button
            className="cartMenuItems"
            style={
              keyValue === "4"
                ? { backgroundColor: "#2F3856", border: "1px solid #2F3856", padding: "0" }
                : { backgroundColor: "#fff", border: "1px solid #fff", padding: "0" }
            }
            onClick={async () => handleKeyvalue("4")}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <SyncIcon color={keyValue === "4" ? "#FFF" : "#555359"} />
              <span className="posMenuIcons" style={{ color: keyValue === "4" ? "#fff" : "#555359" }}>
                Product Sync
              </span>
            </div>
          </button>
        </Col>

        {/* Bottom: Till info + Logout */}
        <Col span={24} style={{ position: "absolute", bottom: "0", left: "0.8%" }}>
          <div style={{ marginTop: "1.2vh", width: "5vw" }}>
            <button
              className="cartMenuItems"
              style={
                keyValue === "5"
                  ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" }
                  : { backgroundColor: "#fff", border: "1px solid #fff", display: "flex", flexDirection: "column" }
              }
              onClick={() => handleKeyvalue("5")}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "0.5vw",
                  border: "1px solid #555359",
                  borderRadius: "50%",
                }}
              >
                <img src={userIcon} style={{ height: "2vh" }} />
              </div>
              <p className="posMenuTill" style={{ color: keyValue === "9" ? "#fff" : "#555359" }}>
                Till Id : {useAuthStore.getState().tillValue?.name}
              </p>
            </button>
          </div>
          <div id="step6" style={{ marginTop: "1.2vh" }}>
            <button
              className="cartMenuItems"
              style={keyValue === "10" ? { backgroundColor: "#2F3856", border: "1px solid #2F3856" } : { backgroundColor: "#fff", border: "1px solid #fff" }}
              onClick={() => {
                const posConfig = usePOSConfigStore.getState().posConfig;
                if (posConfig?.shiftClose === "Y") {
                  if (posConfig?.showDenominations === "Y") {
                    history.push("/close-till");
                  } else if (posConfig?.showDenominations === "N") {
                    history.push("/close-till-all");
                  }
                } else {
                  // SidebarNav triggers the main logout handler in SuperMarket
                  // which clears cookies + auth before navigating to sign-in
                  history.push("/");
                }
                handleKeyvalue("10");
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <img src={Logout} style={{ height: "3vh" }} />
              </div>
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(SidebarNav);
